var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['buttons-container']},_vm._l((_vm.buttons),function(button,index){return _c(_vm.componentName(button.type),{key:index,tag:"component",class:_vm.$style['button'],attrs:{"button":button}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }